import { useCallback, useState, type MouseEvent } from 'react';

export default function useArtistEventChatHeaderMenu() {
  const [chatHeaderMenuOpen, setOpen] = useState(false);
  const [chatHeaderMenuPosition, setPosition] = useState<{left: number; top: number} | null>(null);
  const closeChatHeaderMenu = useCallback(() => { setOpen(false); setPosition(null); }, []);
  const toggleChatHeaderMenu = useCallback((event: MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (chatHeaderMenuOpen) { closeChatHeaderMenu(); return; }
    const rect = event.currentTarget.getBoundingClientRect();
    const menuWidth = 176;
    setPosition({
      left: Math.min(Math.max(12, rect.right - menuWidth), window.innerWidth - menuWidth - 12),
      top: Math.min(rect.bottom + 8, window.innerHeight - 96),
    });
    setOpen(true);
  }, [chatHeaderMenuOpen, closeChatHeaderMenu]);
  return { chatHeaderMenuOpen, chatHeaderMenuPosition, closeChatHeaderMenu, toggleChatHeaderMenu };
}
